module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "half"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("DIE WEHRMACHT IM KAMPF")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("OPERATION "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CRUSADER")]), _vm._v(": TANK WARFARE IN THE DESERT, TOBRUK 1941")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("HERMANN BÜSCHLEB")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_vm._v(" TRANSLATED BY DAVID DORONDO SERIES EDITOR: MATTHIAS STROHN")]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pub.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1436a9fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title.vue
// module id = 63
// module chunks = 0